{
  "common": {
    "login": "logga in",
    "error": "An fel occurred",
    "goHome": "gå hem",
    "loading": "laddar..."
  },
  "pages": {
    "login": {
      "pageTitle": "logga in"
    },
    "notFound": {
      "message": "sida inte hittad",
      "title": "oops"
    },
    "dashboard": {
      "title": "Widget Items",
      "createButton": "ny Widget Item",
      "noData": "nej items hittad",
      "columns": {
        "name": "namn",
        "description": "beskrivning",
        "status": "status",
        "createdOn": "skapad On"
      },
      "status": {
        "active": "aktiv",
        "inactive": "inaktiv"
      },
      "createTitle": "Create Widget Item",
      "form": {
        "name": "namn",
        "description": "beskrivning",
        "isActive": "aktiv",
        "nameRequired": "namn is obligatorisk."
      }
    }
  }
}
